export const DEFAULT_LOCALE = 'en-US';
export const LOCALE_INFOS = { 'ar-SA': {
        characterOrder: 'rtl',
        displayName: 'العربية',
    }, 'bg-BG': {
        characterOrder: 'ltr',
        displayName: 'Български',
    }, 'bn-BD': {
        characterOrder: 'ltr',
        displayName: 'বাংলা',
    }, 'ca-ES': {
        characterOrder: 'ltr',
        displayName: 'Català',
    }, 'cs-CZ': {
        characterOrder: 'ltr',
        displayName: 'Čeština',
    }, 'da-DK': {
        characterOrder: 'ltr',
        displayName: 'Dansk',
    }, 'de-DE': {
        characterOrder: 'ltr',
        displayName: 'Deutsch',
    }, 'el-GR': {
        characterOrder: 'ltr',
        displayName: 'Ελληνικά',
    }, 'en-GB': {
        characterOrder: 'ltr',
        displayName: 'English (United Kingdom)',
    }, 'en-US': {
        characterOrder: 'ltr',
        displayName: 'English (United States)',
    }, 'es-ES': {
        characterOrder: 'ltr',
        displayName: 'Español (España)',
    }, 'es-MX': {
        characterOrder: 'ltr',
        displayName: 'Español (México)',
    }, 'et-EE': {
        characterOrder: 'ltr',
        displayName: 'Eesti',
    }, 'fr-CA': {
        characterOrder: 'ltr',
        displayName: 'Français (Canada)',
    }, 'fr-FR': {
        characterOrder: 'ltr',
        displayName: 'Français (France)',
    }, 'gl-ES': {
        characterOrder: 'ltr',
        displayName: 'Galego',
    }, 'he-IL': {
        characterOrder: 'rtl',
        displayName: 'עברית',
    }, 'hi-IN': {
        characterOrder: 'ltr',
        displayName: 'हिन्दी',
    }, 'hr-HR': {
        characterOrder: 'ltr',
        displayName: 'Hrvatski',
    }, 'hu-HU': {
        characterOrder: 'ltr',
        displayName: 'Magyar',
    }, 'id-ID': {
        characterOrder: 'ltr',
        displayName: 'Indonesia',
    }, 'is-IS': {
        characterOrder: 'ltr',
        displayName: 'Íslenska',
    }, 'it-IT': {
        characterOrder: 'ltr',
        displayName: 'Italiano',
    }, 'ja-JP': {
        characterOrder: 'ltr',
        displayName: '日本語',
    }, 'kk-KZ': {
        characterOrder: 'ltr',
        displayName: 'Қазақ тілі',
    }, 'kn-IN': {
        characterOrder: 'ltr',
        displayName: 'ಕನ್ನಡ',
    }, 'ko-KR': {
        characterOrder: 'ltr',
        displayName: '한국어',
    }, 'lt-LT': {
        characterOrder: 'ltr',
        displayName: 'Lietuvių',
    }, 'lv-LV': {
        characterOrder: 'ltr',
        displayName: 'Latviešu',
    }, 'ml-IN': {
        characterOrder: 'ltr',
        displayName: 'മലയാളം',
    }, 'mr-IN': {
        characterOrder: 'ltr',
        displayName: 'मराठी',
    }, 'nb-NO': {
        characterOrder: 'ltr',
        displayName: 'Norsk bokmål',
    }, 'nl-NL': {
        characterOrder: 'ltr',
        displayName: 'Nederlands',
    }, 'pl-PL': {
        characterOrder: 'ltr',
        displayName: 'Polski',
    }, 'pt-BR': {
        characterOrder: 'ltr',
        displayName: 'Português (Brasil)',
    }, 'pt-PT': {
        characterOrder: 'ltr',
        displayName: 'Português (Portugal)',
    }, 'ro-RO': {
        characterOrder: 'ltr',
        displayName: 'Română',
    }, 'ru-RU': {
        characterOrder: 'ltr',
        displayName: 'Русский',
    }, 'sk-SK': {
        characterOrder: 'ltr',
        displayName: 'Slovenčina',
    }, 'sr-Cyrl-ME': {
        characterOrder: 'ltr',
        displayName: 'Српски (ћирилица, Црна Гора)',
    }, 'sr-Latn': {
        characterOrder: 'ltr',
        displayName: 'Srpski (latinica)',
    }, 'sv-SE': {
        characterOrder: 'ltr',
        displayName: 'Svenska',
    }, 'ta-IN': {
        characterOrder: 'ltr',
        displayName: 'தமிழ்',
    }, 'te-IN': {
        characterOrder: 'ltr',
        displayName: 'తెలుగు',
    }, 'th-TH': {
        characterOrder: 'ltr',
        displayName: 'ไทย',
    }, 'tr-TR': {
        characterOrder: 'ltr',
        displayName: 'Türkçe',
    }, 'uk-UA': {
        characterOrder: 'ltr',
        displayName: 'Українська',
    }, 'vi-VN': {
        characterOrder: 'ltr',
        displayName: 'Tiếng Việt',
    }, 'zh-CN': {
        characterOrder: 'ltr',
        displayName: '中文（简体）',
    }, 'zh-HK': {
        characterOrder: 'ltr',
        displayName: '中文（中國香港特別行政區）',
    }, 'zh-TW': {
        characterOrder: 'ltr',
        displayName: '中文（繁體）',
    } };
